import React from "react";
import { getOrganizingStatus } from "src/services/file.service";
import { Stack } from "@mui/material";
import { Typography } from "@mui/material";
import TextShimmerMotion from "../shadcn-space/animated-text/animated-text-05";
import { ReactWebStore } from 'react-webstore';

class OrganizingStatus extends React.Component {
    constructor(props) {
        super(props);

        this.rws = new ReactWebStore();
        this.state = {
            refreshCounter: 0,
            uploading: false,
            pending: 0,
            currentStatus: null,
            waiting: false
        };

        this.timeoutId = null;
    }

    async componentDidMount() {
        await this.fetchOrganizingStatus();

        this.rws.subscribe('sync_organizing_status', async (e) => {
            if (this.rws.getStore(e.type) == 'success') {
                this.fetchOrganizingStatus();
            }
        })

        this.rws.subscribe('is_file_uploading', async (e) => {
            if (this.rws.getStore(e.type) == 'true') {
                this.setState({ uploading: true, waiting: false });
            } else {
                this.setState({ uploading: false, waiting: true });
            }
        })
        
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.currentStatus !== this.state.currentStatus || prevState.pending !== this.state.pending) {
            if (this.props?.onExistsChange) {
                this.props.onExistsChange(!!this.state.currentStatus || this.state.pending > 0);
            }
        }
    }

    async componentWillUnmount() {
        if (this.timeoutId) {
            clearTimeout(this.timeoutId);
            this.timeoutId = null;
        }
    }

    async fetchOrganizingStatus() {
        const { currentStatus: existingCurrentStatus, pending: existingPending } = this.state;

        let response = await getOrganizingStatus();
        const newCurrentStatus = (response && response.organizing > 0) ? 'organizing' :
            (response && response.reading > 0) ? 'reading' :
                (response && response.understanding > 0) ? 'understanding' :
                    (response && response.processing > 0) ? 'processing' :
                        (response && response.pending > 0) ? 'pending' : null;

        const statusChanged = existingCurrentStatus !== newCurrentStatus;
        if (response?.pending !== existingPending) {
            this.setState({ pending: response?.pending || 0 });
        }

        if (response?.pending_actions && statusChanged && !newCurrentStatus) {
            this.rws.store('sync_actions', 'success');
        }

        if (newCurrentStatus || statusChanged) {
            this.setState({
                currentStatus: newCurrentStatus,
                waiting: false
            });
            if (this.state.refreshCounter < 120) {
                this.setState({ refreshCounter: this.state.refreshCounter + 1 });
                if (this.timeoutId) {
                    clearTimeout(this.timeoutId);
                    this.timeoutId = null;
                }
                this.timeoutId = setTimeout(() => {
                    this.fetchOrganizingStatus();
                }, 1000);
            }
        }
    }

    render() {
        const { uploading, currentStatus, waiting } = this.state;

        if (!uploading && !waiting && !currentStatus && this.state.pending === 0) {
            return null;
        }

        return (
            <Stack direction="row" spacing={1} alignItems="center" sx={{ opacity: 0.8 }}>
                {(uploading) ? (
                    <Typography variant="subtitle2" color='primary' sx={{ display: 'flex', alignItems: 'center' }}>
                        <TextShimmerMotion text="Uploading..." />
                    </Typography>
                ) : null}
                {(waiting) ? (
                    <Typography variant="subtitle2" color='primary' sx={{ display: 'flex', alignItems: 'center' }}>
                        <TextShimmerMotion text="Waiting..." />
                    </Typography>
                ) : null}
                {(this.state.pending > 0) ? (
                    <Typography variant="subtitle2" color='primary' sx={{ display: 'flex', alignItems: 'center' }}>
                        <TextShimmerMotion text={`Pending ${this.state.pending} file${this.state.pending > 1 ? 's' : ''}...`} />
                    </Typography>
                ) : null}
                <Typography variant="subtitle2" color={'primary'} sx={{ display: 'flex', alignItems: 'center' }}>
                    {(currentStatus === 'processing') ? (
                        <TextShimmerMotion text="Processing..." />
                    ) : null}
                    {(currentStatus === 'reading') ? (
                        <TextShimmerMotion text="Reading..." />
                    ) : null}
                    {(currentStatus === 'understanding') ? (
                        <TextShimmerMotion text="Understanding..." />
                    ) : null}
                    {(currentStatus === 'organizing') ? (
                        <TextShimmerMotion text="Organizing..." />
                    ) : null}
                </Typography>

            </Stack>
        );
    }
}

export default OrganizingStatus;
